import { IProducPosttDtoModel } from "../../../models/product/dto/product-create/product-post-dto.model";
import { IProductModel } from "../../../models/product/product.model";
import { IModelMapping } from "../../generic/model.mapping";

export class ProductMapping implements IModelMapping<IProducPosttDtoModel, IProductModel> {
    toApplicationModel(model: IProducPosttDtoModel): IProductModel {
        throw new Error('not implemented');
    }
    toDtoModel(model: IProductModel): IProducPosttDtoModel {
        return {
            countryOfOriginCode: model.countryOfOriginCode,
            productTypeCode: '',
            englishShortTitle: '',
            partNumber: model.partNumber,
            partStatusCode: '',
            componentStatusCode: '',
            commodity: {
                ukCode: String(model.commodity.uk),
                usCode: String(model.commodity.us),
              },
            taxonomyCode: '',
            taxRateCategoryCode: model.taxRateCategoryId,
            discountCategoryCode: '',
          } as IProducPosttDtoModel;
    }
    toDtoModels(models: IProductModel[]): IProducPosttDtoModel[] {
        return models.map(x => this.toDtoModel(x));
    }
    toApplicationModels(models: IProducPosttDtoModel[]): IProductModel[] {
        throw new Error('not implemented');
    }
}